import React, { useState, useEffect } from "react";
import { ItemList } from "../ItemList";
import { getServices, filterServices } from "../../services/services";
import "./styles.css";
import { services } from "../../data/services";

export const ItemListContainer = ({
  titleStart,
  titleEnd,
  btnOne,
  btnTwo,
  btnThree,
}) => {
  const [filteredService, setFilteredService] = useState(null);
  const [isActiveOne, setIsActiveOne] = useState(true);
  const [isActiveTwo, setIsActiveTwo] = useState(false);
  const [isActiveThree, setIsActiveThree] = useState(false);

  useEffect(() => {
    setFilteredService(getServices());
  }, []);

  function handleService(e) {
    let catService = e.target.value;
    if (catService === "1") {
      setFilteredService(getServices());
      handleActiveOne();
    } else if (catService === "2") {
      setFilteredService(filterServices(catService));
      handleActiveTwo();
    } else if (catService === "3") {
      setFilteredService(filterServices(catService));
      handleActiveThree();
    } else {
      setFilteredService(getServices());
      handleActiveOne();
    }
  }

  function handleActiveOne() {
    setIsActiveOne(true);
    setIsActiveTwo(false);
    setIsActiveThree(false);
  }

  function handleActiveTwo() {
    setIsActiveOne(false);
    setIsActiveTwo(true);
    setIsActiveThree(false);
  }

  function handleActiveThree() {
    setIsActiveOne(false);
    setIsActiveTwo(false);
    setIsActiveThree(true);
  }

  return (
    <div id="item-list-container">
      <h2>
        {titleStart}
        <span> {titleEnd}</span>
      </h2>
      <div className="item-filter row justify-content-center">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-1">
          <p>Filtrar por: </p>
        </div>
        <div className="col-md-12 col-lg-6">
          <button
            value={"1"}
            className={isActiveOne ? "btn-active" : "btn-inactive"}
            onClick={handleService}
          >
            {btnOne}
          </button>
          <button
            value={"2"}
            className={isActiveTwo ? "btn-active" : "btn-inactive"}
            onClick={handleService}
          >
            {btnTwo}
          </button>
          <button
            value={"3"}
            className={isActiveThree ? "btn-active" : "btn-inactive"}
            onClick={handleService}
          >
            {btnThree}
          </button>
        </div>
      </div>
      <ItemList items={filteredService !== null ? filteredService : services} />
    </div>
  );
};
